import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

import { Select } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import classnames from "classnames";

import { useAppDispatch, useAppSelector } from "_src/store/hooks";
import { setChainId, setNetworkId } from "_src/store/global/reducer";

import Modal from "_src/components/Modal";
import Button from "_src/components/Button";

import { setIsSupportNetworkAction } from "_src/store/global/reducer";

import { chainList } from "_src/utils/chain/chainConfUtil";
import { getChainName } from "_src/utils/chain/chainConfFunc";

import { publicSelectChain } from "./func";

import "./index.less";

const { Option } = Select;

const configChainList = chainList();

const SelectChain = ({ className }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { connected, chainId, isSupportNetworkInfo } = useAppSelector(
    (store) => store.global
  );
  const dispatch = useAppDispatch();

  const goHome = () => {
    history.push("/");
  };

  const changeChain = async ({ networkId, chainId }) => {
    if (connected) {
      // 已经连接钱包操作
      const result = await publicSelectChain(chainId).catch((error) => {
        console.log(error);
      });
      if (result) {
        goHome();
      }
    } else {
      dispatch(setNetworkId(networkId));
      dispatch(setChainId(chainId));
      goHome();
    }
  };

  const handleSelect = (item) => {
    const {
      value: chainId,
      label: { key: networkId },
    } = item;

    changeChain({ networkId, chainId });
  };

  const handleSwitchNetwork = async () => {
    isSupportNetworkInfo;
    changeChain({ ...isSupportNetworkInfo });

    if (connected) {
      // 已经连接钱包操作
      await publicSelectChain(chainId);
    }
  };

  return (
    <div
      id="select-chain-area"
      className={classnames("select-chain-container", className)}
    >
      <Select
        labelInValue={true}
        value={{ value: chainId }}
        onChange={handleSelect}
        getPopupContainer={() => document.getElementById("select-chain-area")}
        className="select-chain-select"
        dropdownClassName="select-chain-dropdown"
        bordered={false}
        suffixIcon={<CaretDownOutlined className="chain-select-suffix" />}
      >
        {configChainList.map((chain) => (
          <Option
            key={chain.chainId}
            className="select-chain-option"
            value={chain.chainId}
          >
            <div key={chain.networkId} className="select-chain-option-content">
              <img src={chain.logo} />
              <div className="select-chain-option-text">
                {chain.networkName}
              </div>
            </div>
          </Option>
        ))}
      </Select>
      <Modal
        width={568}
        className="switch-network-modal"
        title={t("chain.switch_network_title")}
        visible={isSupportNetworkInfo?.show || false}
        handleClose={() => {
          dispatch(
            setIsSupportNetworkAction({ ...isSupportNetworkInfo, show: false })
          );
        }}
      >
        <div className="select-network-desc">
          {
            <Trans
              i18nKey="chain.switch_network_desc"
              values={{
                value: getChainName(isSupportNetworkInfo?.networkId || ""),
              }}
            />
          }
        </div>
        <Button
          bold
          className="select-network-button"
          onClick={handleSwitchNetwork}
        >
          {t("chain.switch_network")}
        </Button>
      </Modal>
    </div>
  );
};

export { publicSelectChain };

export default SelectChain;
